
import React from "react"

function Subscription({ id }) {

    return (
        <>
            <div className="data-view">
                <div className="data-card">
                    <div className="data-card-header">
                        <p className="subtitle subtitle--black">
                            <b>Suscripción</b>
                        </p>
                    </div>
                    <div class="data-card-body">
                        <h4 className="pb-4"><b>Mantente al día con la información más reciente de este contenido dando clic al siguiente botón</b></h4>
                        <a className="button button-secondary" href={`/suscripcion/${id}`} target="_blank">Suscríbete</a>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Subscription